import { Grid } from "@material-ui/core";
import HeaderModal from "../../../global/headerModal";
import ModalBase from "./../../../global/ModalBase";
import { makeStyles } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import { openModalMensualidad, targetBancoAction, obtenerMensualidadesBanco, obtenerMensualidades } from "../../../ducks/bancoDuck";
import { useEffect } from "react";
import TMensualidad from "../TMensualidad";
import FMensualidad from "../FMensualidad";
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck";
export const FCortizadorStyle = makeStyles((theme) => ({
    containerSpacing: {
        margin: "10px 0",
        padding: "1rem",
        overflowY: "scroll",
        maxHeight: "80vh"
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto",
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: "none",
        boxShadow: theme.shadows[10],
        padding: theme.spacing(1, 2, 1),
        minWidth: "99vw",
        minHeight: "99vh",
        maxWidth: "99vw",
        maxHeight: "99vh",
    },
}));

const MMensualidad = () => {
    const { modalMensualidad, banco } = useSelector(store => store.banco)
    const dispatch = useDispatch()
    const classes = FCortizadorStyle();
    const handleClose = () => {

        dispatch(openModalMensualidad({ open: false }))
        dispatch(targetBancoAction({ banco: {}, editar: false }))
    }
    useEffect(() => {
        dispatch(onLoadAnction({message: ""}))
        dispatch(obtenerMensualidadesBanco({ IdBanco: banco.IdBanco })).then(Response => {
            dispatch(offLoadAction())
        })
        dispatch(obtenerMensualidades())
    }, [dispatch, banco.IdBanco])
    return (
        <ModalBase classes={classes} open={modalMensualidad} onClose={handleClose}>
            <HeaderModal handleClose={handleClose} titulo={`Mensualidades para el banco ${banco.Nombre}`} />
            <Grid container className={classes.containerSpacing}>
                <Grid item xs={4}>
                    <FMensualidad />
                </Grid>
                <Grid item xs={8}>
                    <TMensualidad />
                </Grid>
            </Grid>
        </ModalBase>
    )
}
export default MMensualidad